
<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item active"
              aria-current="page"
              style="text-transform: capitalize"
            >
              {{$t('importacion')}}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusiness"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <h5>{{$t('importacion')}}</h5>
            </div>

            <div class="col-md-12">
              <div class="form-control" style="height: 200px">
                <input
                  enctype="multipart/form-data"
                  ref="file"
                  @change="createImage"
                  type="file"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
            </div>

            <div class="col-md-12" style="margin-top: 10px">
              <button @click="openModal()" class="btn btn-primary">
                <i class="fa fa-check-square"></i>
                {{$t('importar')}}
              </button>
              <!--
                            <button @click="importar(1)" class="btn btn-primary"><i class="fa fa-check-square"></i>
                                Importar
                            </button>
                            -->
              <!--<button @click="importar(3)" class="btn btn-primary"><i class="fa fa-check-square"></i>-->
              <!--Importar datos-->
              <!--</button>-->
              <!--<button @click="importar(2)" class="btn btn-primary"><i class="fa fa-check-square"></i>-->
              <!--Importar productos-->
              <!--</button>-->
            </div>
          </div>
        </div>
      </div>

      <!-- <modal name="modal-importar" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{$t("confirmacionImportacionHeader")}}</h4>
                    </div>
                    <div class="modal-body">
                        <div>
                            <p>{{$t("confirmacionImportacionText")}}</p>
                            <p><strong>{{lineasXml}} líneas</strong></p>
                            <p><strong>En {{nameBusiness}}</strong></p>
                        </div>


                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button @click="cerrarModal()" class="btn btn-danger"><i class="fas fa-times"></i>
                                {{$t("cancelar")}}
                            </button>
                            <button @click="importar(1)" class="btn btn-primary"><i class="fas fa-check"></i>
                                {{$t("confirmar")}}
                            </button>
                        </div>
                    </div>
                </div>
            </modal> -->

      <modal
        name="modal-importar"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div class="text-center" v-if="lineasXml < 10000">
          <div class="modal-header">
            <h4 class="modal-title col-12 text-center" style="margin: 0px">
              {{ $t("confirmacionImportacionHeader") }}
            </h4>
          </div>
          <div class="modal-body">
            <div>
              <p>{{ $t("confirmacionImportacionText") }}</p>
              <p style="font-size: 22px">
                <strong>{{ lineasXml }} {{ $t("registros") }}</strong>
              </p>
              <p style="font-size: 22px">
                <strong>{{ $t("en") }} {{ nameBusiness }}</strong>
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button @click="cerrarModal()" class="btn btn-danger">
                <i class="fas fa-times"></i>
                {{ $t("cancelar") }}
              </button>
              <button @click="importar(1)" class="btn btn-primary">
                <i class="fas fa-check"></i>
                {{ $t("confirmar") }}
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <div class="modal-header">
              <h4 class="modal-title col-12 text-center" style="margin: 0px">
                {{ $t("headerError") }}
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <p style="font-size: 22px">{{ $t("bodyError") }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button @click="cerrarModal()" class="btn btn-danger">
                <i class="fas fa-times"></i>
                {{$t('cancelar')}}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>


<script>
import XLSX from "xlsx";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
} from "element-ui";
import swal from "sweetalert2";

export default {
  name: "ImportacionExcels",
  data() {
    return {
      listDatos: [],

      listBusiness: [],
      idBusiness: 0,
      file: "",
      nameBusiness: "",
      lineasXml: 0,
      nuevosProductos: null,
    };
  },
  created() {
    this.getBusiness();
  },
  methods: {
    openModal() {
      if (this.file) {
        this.$modal.show("modal-importar");

        const business = this.listBusiness.filter((el) => {
          return this.idBusiness == el.id;
        });

        if (business.length == 0) {
        } else {
          this.nameBusiness = business[0].establishmentName;
        }

        let e = this.file;

        var files = e.target.files,
          f = files[0];
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);

          var workbook = XLSX.read(data, { type: "array", cellDates: true });
          let sheetName = workbook.SheetNames[0];

          let worksheet = workbook.Sheets[sheetName];

          vm.listDatos = XLSX.utils.sheet_to_json(worksheet);

          let rango = XLSX.utils.decode_range(worksheet["!ref"]);

          vm.lineasXml = rango.e.r;
        };
        reader.readAsArrayBuffer(f);
      } else {
        swal({
          title: this.$t('atencion'),
          text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion')+ " ",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },

    cerrarModal() {
      this.$modal.hide("modal-importar");
    },

    saveVentas() {
      this.loadingGeneral = Loading.service({
        text: this.$t('importandoVentasDelNegocio'),
      });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idBusiness: this.idBusiness,
        listDatos: this.listDatos,
      };

      let vm = this;
      let controller = "saveVentas";
      this.axios
        .post(
          this.$store.getters.apiUrl + "importacion/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.loadingGeneral.close();
            vm.saveMovimientosAlmacen();
            console.log(response);
            if (response.data.result != "") {
              vm.nuevosProductos = response.data.result;
              let nProdtext = "<ul>"
              vm.nuevosProductos.forEach(element => {
                  nProdtext += '<li>'+element+'</li>'
              });   
              nProdtext += '</ul>'

              swal({
                title: vm.$t('nuevosProductos'),
                html: vm.$t('seHanCreadoLosSiguientesProductos')+ ": "+nProdtext,
                confirmButtonClass: "btn btn-info btn-fill",
                });
            }
          } else {
            vm.loadingGeneral.close();
          }
        })
        .catch(function (error) {
          vm.loadingGeneral.close();
          console.log(error);
        });
    },

    saveMovimientosAlmacen() {
      this.loadingGeneral = Loading.service({
        text: this.$t('importandoMovimientosDeAlmacen'),
      });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idBusiness: this.idBusiness,
        listDatos: this.listDatos,
      };

      let vm = this;
      let controller = "saveMovimientosAlmacen";
      this.axios
        .post(
          this.$store.getters.apiUrl + "importacion/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.loadingGeneral.close();
          } else {
            vm.loadingGeneral.close();
          }
        })
        .catch(function (error) {
          vm.loadingGeneral.close();
          console.log(error);
        });
    },

    importarCarta(productos) {
      this.loadingGeneral = Loading.service({ text: this.$t('importandoDatos') });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idBusiness: this.idBusiness,
        listDatos: this.listDatos,
      };

      let vm = this;
      let controller = productos ? "saveProductos" : "saveDatos";
      this.axios
        .post(
          this.$store.getters.apiUrl + "importacion/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.loadingGeneral.close();
          } else {
            vm.loadingGeneral.close();
          }
        })
        .catch(function (error) {
          vm.loadingGeneral.close();
          console.log(error);
        });
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          if (response.data.response) {
            if (vm.$store.getters.idBusiness) {
              vm.idBusiness = vm.$store.getters.idBusiness;
            } else {
              vm.idBusiness = response.data.result[0].id;
            }

            vm.listBusiness = response.data.result;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    createImage(e) {
      this.file = e;
    },

    importar(opcion) {
      if (this.file) {
        let e = this.file;

        var files = e.target.files,
          f = files[0];
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);

          var workbook = XLSX.read(data, { type: "array", cellDates: true });
          let sheetName = workbook.SheetNames[0];

          let worksheet = workbook.Sheets[sheetName];

          vm.listDatos = XLSX.utils.sheet_to_json(worksheet);

          if (opcion === 1) {
            vm.saveVentas();
          } else if (opcion === 2) {
            vm.importarCarta(true);
          } else {
            vm.importarCarta(false);
          }
          
        };
        reader.readAsArrayBuffer(f);
        vm.cerrarModal();
      } else {
        swal({
          title: this.$t('atencion'),
          text: this.$t('tienesQueSeleccionarUnArchivoDeImportacion'),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Importacion/ImportacionExcels.vue